import { Textarea } from "@/components/ui/textarea";
import { ChevronDown } from "lucide-react";

interface EditableTitleProps { title: string; isEditing: boolean; isOpen: boolean; onTitleChange: (title: string) => void; }

const EditableTitle = ({ title, isEditing, isOpen, onTitleChange }: EditableTitleProps) => (
  <div className="flex items-center gap-2">
    {isEditing ? (
      <Textarea value={title} onChange={(e) => onTitleChange(e.target.value)} className="font-medium text-xl resize-none mb-2" onClick={(e) => e.stopPropagation()} />
    ) : (
      <>
        <h3 className="text-xl font-medium">{title}</h3>
        <ChevronDown className={`h-5 w-5 text-accent transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </>
    )}
  </div>
);

export default EditableTitle;
